import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const KohaImportPage = lazyNamed(() => import('./pages'), 'KohaImportPage');
const KohaImportBatchPage = lazyNamed(() => import('./pages'), 'KohaImportBatchPage');

/**
 * Staff routes for features/koha-import. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const kohaImportRoutes: RouteObject[] = [
  { path: 'admin/koha-import', element: <RequirePermission permission={['import']}><KohaImportPage /></RequirePermission> },
  { path: 'admin/koha-import/:batchId', element: <RequirePermission permission={['import']}><KohaImportBatchPage /></RequirePermission> },
];
